import { defineMessages } from "../i18n/core";

export const trialBannerMessages = defineMessages({
  "pt-BR": {
    remaining: (n: number) => (n === 1 ? "Teste gratuito: falta 1 dia" : `Teste gratuito: faltam ${n} dias`),
    activeDetail: (date: string) => `O teste vai até ${date}. Para continuar com os backups depois disso, fale com a gente.`,
    endedTitle: (date: string) => `Seu teste terminou em ${date}.`,
    endedDetail: (until: string | null) =>
      until
        ? `Os backups pararam; as restaurações continuam liberadas até ${until}. Para voltar a fazer backup, fale com a gente.`
        : "Os backups pararam; as restaurações continuam liberadas por alguns dias. Para voltar a fazer backup, fale com a gente.",
    whatsapp: "Falar no WhatsApp",
    mail: (address: string) => `Escrever para ${address}`,
    whatsappText: (org: string) => `Olá! Quero continuar com o E-BACKUP depois do teste. Organização: ${org}`,
  },
  "en-US": {
    remaining: (n: number) => (n === 1 ? "Free trial: 1 day left" : `Free trial: ${n} days left`),
    activeDetail: (date: string) => `The trial runs until ${date}. To keep backing up after that, talk to us.`,
    endedTitle: (date: string) => `Your trial ended on ${date}.`,
    endedDetail: (until: string | null) =>
      until
        ? `Backups have stopped; restores remain available until ${until}. To back up again, talk to us.`
        : "Backups have stopped; restores remain available for a few days. To back up again, talk to us.",
    whatsapp: "Chat on WhatsApp",
    mail: (address: string) => `Write to ${address}`,
    whatsappText: (org: string) => `Hi! I want to keep using E-BACKUP after the trial. Organization: ${org}`,
  },
  es: {
    remaining: (n: number) => (n === 1 ? "Prueba gratuita: falta 1 día" : `Prueba gratuita: faltan ${n} días`),
    activeDetail: (date: string) => `La prueba dura hasta el ${date}. Para seguir con las copias después, habla con nosotros.`,
    endedTitle: (date: string) => `Tu prueba terminó el ${date}.`,
    endedDetail: (until: string | null) =>
      until
        ? `Las copias se detuvieron; las restauraciones siguen disponibles hasta el ${until}. Para volver a hacer copias, habla con nosotros.`
        : "Las copias se detuvieron; las restauraciones siguen disponibles unos días. Para volver a hacer copias, habla con nosotros.",
    whatsapp: "Hablar por WhatsApp",
    mail: (address: string) => `Escribir a ${address}`,
    whatsappText: (org: string) => `¡Hola! Quiero seguir con E-BACKUP después de la prueba. Organización: ${org}`,
  },
});
